import React, { useState, useEffect, useMemo, useRef, useTransition } from "react";
import {
  Table,
  Input,
  Button,
  Card,
  Row,
  Col,
  Dropdown,
  Menu,
  Space,
  DatePicker,
  Typography,
  Image,
  Tabs,
  Tooltip,
  message,
} from "antd";
import {
  SearchOutlined,
  EyeOutlined,
  FilterOutlined,
  CloseOutlined,
  CheckOutlined,
  HourglassOutlined,
  DownloadOutlined,
  ExportOutlined,
  PrinterOutlined,
  LeftOutlined,
  InfoCircleOutlined,
  WarningFilled,
  RightOutlined,
} from "@ant-design/icons";
import Dashboard from "../../../layouts/Dashboard";
import ReactLoading from "react-loading";
import moment from "moment";
import useAxios from "../../../hooks/useAxios";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import MetaDataTab from "../components/MetaDataTab";
import { capitalizeEachWord } from "../../../utils/commonFunctions";
import swal from "sweetalert";
import printJS from "print-js";
import SkeletonLoader from "../components/SkeletonLoader";
import RenderFiles from "../../CandidateDashboard/components/RenderFiles";
import { checkBulkPermissions } from "../../../utils/checkPermission";

const { Title, Text } = Typography;
const { TabPane } = Tabs;

const caseConversion = (string) => {
  return string?.replace(/([A-Z])/g, " $1").replace(/^./, function (str) {
    return str?.toUpperCase();
  });
};

function formatFileSize(bytes) {
  const sizeInKB = bytes / 1024;
  if (sizeInKB >= 1024) {
    const sizeInMB = sizeInKB / 1024;
    return `${sizeInMB.toFixed(2)} MB`;
  } else {
    return `${sizeInKB.toFixed(2)} KB`;
  }
}

const SiteHrAuditPage = () => {
  const api = useAxios();
  const { empId, candidateId } = useParams();
  const [documents, setDocuments] = useState([]);
  const [load, setLoad] = useState(false);
  const [status, setStatus] = useState("Pending");
  const [docExtension, setDocExtension] = useState("");
  const [activeDoc, setActiveDoc] = useState(1);
  const [size, setSize] = useState(1);
  const [activeDocData, setActiveDocData] = useState(null);
  const [candidateDetails, setCandidateDetails] = useState(null);
  const [rejectionReason, setRejectionReason] = useState(null);
  const [acceptReason, setAcceptReason] = useState(null);
  const [isRejectEnable, setIsRejectEnable] = useState(false);
  const [isAcceptableEnable, setIsAcceptableEnable] = useState(false);
  const [fileblob, setFileBlob] = useState("");
  const [loading, setLoading] = useState(false);
  const [personalDetails,setPersonalDetails] = useState(true)
  const [pending,startTransition] = useTransition()
  const [permissions, setPermissions] = useState({
    canView: true, canReupload: false, canNoProblem: false,
    canDownload: false, canPrint: false,
  });

  useEffect(() => {
    const fetchPerms = async () => {
      const role = localStorage.getItem("user.role");
      if (!role) return;
      const checks = [
        { entityType: "site_hr_audit_document_module", permission: "view_site_hr_audit_document" },
        { entityType: "site_hr_audit_document_module", permission: "reupload_site_hr_audit_document" },
        { entityType: "site_hr_audit_document_module", permission: "no_problem_site_hr_audit_document" },
        { entityType: "site_hr_audit_document_module", permission: "download_site_hr_audit_document" },
        { entityType: "site_hr_audit_document_module", permission: "print_site_hr_audit_document" },
      ];
      try {
        const results = await checkBulkPermissions(role, checks);
        const isAllowed = (perm) => results.find((r) => r.permission === perm)?.allowed || false;
        setPermissions({
          canView: isAllowed("view_site_hr_audit_document"),
          canReupload: isAllowed("reupload_site_hr_audit_document"),
          canNoProblem: isAllowed("no_problem_site_hr_audit_document"),
          canDownload: isAllowed("download_site_hr_audit_document"),
          canPrint: isAllowed("print_site_hr_audit_document"),
        });
      } catch (err) { console.log(err); }
    };
    fetchPerms();
  }, []);

  const getAllDocuments = async () => {
    try {
      const result = await api.get(
        `/makercheaker/AllCandidateDocuments/${empId}`,
        { tokenType: "user" }
      );
      let srces = [];
      const {
        bankDetails,
        candidateDocuments,
        personalDetails,
        companyDocuments,
      } = result.data;
      const {
        aadharCardImage,
        candidatePhoto,
        candidateSignature,
        panCardImage,
        _id,
      } = personalDetails[0];

      if (aadharCardImage?.length !== 0) {
        if (
          aadharCardImage[0]?.auditingDetails?.documentStatusByCheker === false
        ) {
          srces.push({
            path: aadharCardImage[0].path,
            docData: aadharCardImage[0],
            name: caseConversion(aadharCardImage[0]?.fieldname),
            type: "Aadhar_Card",
            documentId: "",
            auditingDetails: aadharCardImage[0]?.auditingDetails,
          });
        }
      }
      if (candidatePhoto?.length !== 0) {
        if (
          candidatePhoto[0]?.auditingDetails?.documentStatusByCheker === false
        ) {
          srces.push({
            path: candidatePhoto[0].path,
            docData: candidatePhoto[0],
            name: caseConversion(candidatePhoto[0]?.fieldname),
            type: "Profile_Image",
            documentId: "",
            auditingDetails: candidatePhoto[0]?.auditingDetails,
          });
        }
      }
      if (candidateSignature?.length !== 0) {
        if (
          candidateSignature[0]?.auditingDetails?.documentStatusByCheker ===
          false
        ) {
          srces.push({
            path: candidateSignature[0].path,
            docData: candidateSignature[0],
            name: caseConversion(candidateSignature[0]?.fieldname),
            type: "Signature",
            documentId: "",
            auditingDetails: candidateSignature[0]?.auditingDetails,
          });
        }
      }
      if (panCardImage?.length !== 0) {
        if (
          panCardImage[0]?.auditingDetails?.documentStatusByCheker === false
        ) {
          srces.push({
            path: panCardImage[0].path,
            docData: panCardImage[0],
            name: caseConversion(panCardImage[0]?.fieldname),
            type: "Pan_Card",
            documentId: "",
            auditingDetails: panCardImage[0]?.auditingDetails,
          });
        }
      }

      if (bankDetails?.length !== 0) {
        const { files: banksFiles } = bankDetails[0];
        for (let key of banksFiles) {
          if (key?.auditingDetails?.documentStatusByCheker === false) {
            srces.push({
              path: key.path,
              docData: key,
              name: caseConversion(key?.fieldname),
              type: "Candidate_Document",
              documentId: bankDetails[0]?._id,
              auditingDetails: key?.auditingDetails,
            });
          }
        }
      }

      if (candidateDocuments?.length !== 0) {
        for (let doc of candidateDocuments) {
          const { files: candidateFiltes, _id } = doc;
          for (let key of candidateFiltes) {
            if (key?.auditingDetails?.documentStatusByCheker === false) {
              srces.push({
                path: key.path,
                docData: key,
                name: caseConversion(key?.fieldname),
                type: "Candidate_Document",
                documentId: _id,
                auditingDetails: key?.auditingDetails,
              });
            }
          }
        }
      }

      for (let key of companyDocuments) {
        if (key?.auditingDetails?.documentStatusByCheker === false) {
          const { files } = key;
          srces.push({
            path: key?.filePath,
            docData: files[0],
            name: key?.companyDocumentId?.formName,
            type: "Company_Document",
            documentId: key?._id,
            auditingDetails: key?.auditingDetails,
          });
        }
      }
      setPersonalDetails(personalDetails[0])
      setDocuments(srces);
    } catch (err) {
      console.log(err);
    }
  };

  const getFileSize = async (url) => {
    try {
      setLoading(true);
      const response = await fetch(url, { mode: "cors" });
      const blob = await response.blob();
      const contentLength = response.headers.get("Content-Length");
      let sizeInBytes = contentLength ? parseInt(contentLength) : null;
      
      if(!sizeInBytes) {
        sizeInBytes = blob.size 
      }
      startTransition(() => {
        if (fileblob) URL.revokeObjectURL(fileblob);
        setFileBlob(URL.createObjectURL(blob));
      })
      if (sizeInBytes) {
        return formatFileSize(sizeInBytes);
      } else {
        return "N/A";
      }
    } catch (error) {
      return "N/A";
    } finally {
      setLoading(false);
    }
  };

  const downloadDoc = async () => {
    try {
      setLoad(true);
      const a = document.createElement("a");
      a.href = fileblob;
      a.download = `${activeDocData?.name}.${docExtension}`;
      a.click();
      document.body.removeChild(a);
      setLoad(false);
    } catch (err) {
      console.log(err);
      setLoad(false);
    }
  };

  const onClickPrint = () => {
    const ext = activeDocData?.docData?.originalname
      ?.split(".")
      .pop()
      ?.toLowerCase();
    if (["jpg", "png", "jpeg", "jfif"].includes(ext)) {
      printJS({
        printable: fileblob,
        documentTitle: "Kochartech Pvt. Ltd.",
        type: "image",
        imageStyle: "object-fit:contain;",
        onError: () => {
          message.error("Something went wront while print.", 3);
        },
      });
    } else if (ext === "pdf") {
      printJS({
        printable: fileblob,
        type: "pdf",
        onError: () => {
          message.error("Something went wront while print.", 3);
        },
      });
    }
  };

  const openDocument = () => {
    let path = "";
    if (activeDocData?.type?.toLowerCase() === "company_document") {
      path = activeDocData?.docData?.path;
    } else {
      path = `${activeDocData?.docData?.destination}/${activeDocData?.docData?.filename}`;
    }
    window.open(`/doc/${encodeURIComponent(path)}`, "_blank");
  };

  const getCandidateDetails = async () => {
    try {
      const result = await api.get(
        `/candidateDocuments/candidateAllDetails/getCandidateDetails/${candidateId}`,
        { tokenType: "user" }
      );
      setCandidateDetails(result.data);
    } catch (err) {
      console.log(err);
    }
  };

  //   const filteredDoc = useMemo(() => {
  //     return documents?.filter((ele) => {
  //       const { auditingDetails } = ele;
  //       if (status === "Pending" && auditingDetails === null) {
  //         return true;
  //       } else if (
  //         status === "Completed" &&
  //         (auditingDetails?.documentStatusByCheker === false ||
  //           auditingDetails?.documentStatusByCheker === true)
  //       ) {
  //         return true;
  //       }
  //     });
  //   }, [documents, status]);

  useEffect(() => {
    if (documents.length === 0) return;
    const init = async () => {
      const _size = await getFileSize(documents[activeDoc - 1]?.path);
     startTransition(() => {
        setSize(_size);
      })
    };

    setActiveDocData(documents[activeDoc - 1]);
    if (documents[activeDoc - 1]) {
      const ext = documents[activeDoc - 1].docData?.filename
        ?.split(".")
        ?.pop()
        ?.toLowerCase();
      setDocExtension(ext);
      init();
    }
  }, [documents, activeDoc, status]);

  useEffect(() => {
    if (!empId || !candidateId) return;
    const init = async () => {
      try {
        setLoad(true);
        await Promise.all([getAllDocuments(), getCandidateDetails()]);
      } catch (err) {
        console.log(err);
      } finally {
        setLoad(false);
      }
    };
    init();
  }, [empId, candidateId]);

  const rejectAadhar = async () => {
    try{
      await api.put(
        `/candidate/aadharCardImageStatus/${candidateId}`,
        {
          Status: false,
          aadharRejection: "Audit Failed",
        },
        { tokenType: "user" }
      );
    }catch(err) {
      console.error(err)
      throw err
    }
  };

  const rejectPan = async () => {
    try{
      await api.put(
        `/candidate/panCardImageStatus/${candidateId}`,
        {
          Status: false,
          panRejection: "Audit Failed",
        },
        { tokenType: "user" }
      );
    }catch(err) {
      console.error(err)
      throw err
    }
  };

  const rejectProfile = async () => {
    try{
      await api.put(
        `/candidate/candidatePhotoStatus/${candidateId}`,
        {
          Status: false,
          candidatePhotoRejection: "Audit Failed",
        },
        { tokenType: "user" }
      );
    }catch(err) {
      console.error(err)
      throw err
    }
  };

  const rejectSignature = async () => {
    try{
      await api.put(
        `/candidate/candidateSignatureStatus/${candidateId}`,
        {
          Status: false,
          candidateSignatureRejection: "Audit Failed",
        },
        { tokenType: "user" }
      );
    }catch(err) {
      console.log(err)
      throw err
    }
  };

  const rejectCandidateDocument = async () => {
    try{
      await api.put(
        `/candidateDocuments/candidateDocumentStatus/Invalid`,
        {
          fieldName: activeDocData?.docData?.fieldname,
          documentId: activeDocData?.documentId,
          DocumentStatusName: true,
          rejectionReason: "Audit Failed",
        },
        { tokenType: "user" }
      );
    }catch(err) {
      console.log(err)
      throw err
    }
  };

  const rejectCompanyDocument = async () => {
    try{
      await api.put(
        `/companyDocuments/CandidateDocumentStatusByHR`,
        {
          id: activeDocData?.documentId,
          userId: "",
          formStatusByHR: false,
          remarks: "Audit Failed",
        },
        { tokenType: "user" }
      );
    }catch(err) {
      console.log(err)
      throw err
    }
  };

  const documentStatusMark = async (status) => {
    if(!status){
      const flag = await swal({
        title: "Warning",
        icon: "warning",
        content: {
          element: "div",
          attributes: {
            innerHTML: `<p style="text-align:center">Do you want to proceed ?</p>`,
          },
        },
        buttons: {
          cancel: true,
          confirm: true,
        },
      });
  
      if (!flag) return;
    }
    try {
      setLoad(true);
      await api.put(
        `/makercheaker/maker/candidateDocuments`,
        {
          makerchekerAuditingId: activeDocData?.auditingDetails?._id || "",
          documentStatus: status,
          rejectionReason: rejectionReason,
          acceptanceRemarksByMaker: acceptReason,
        },
        { tokenType: "user" }
      );
      if (status) {
        if (activeDocData?.type?.toLowerCase() === "aadhar_card") {
          await rejectAadhar();
        } else if (activeDocData?.type?.toLowerCase() === "pan_card") {
          await rejectPan();
        } else if (activeDocData?.type?.toLowerCase() === "profile_image") {
          await rejectProfile();
        } else if (activeDocData?.type?.toLowerCase() === "signature") {
          await rejectSignature();
        } else if (
          activeDocData?.type?.toLowerCase() === "candidate_document"
        ) {
          await rejectCandidateDocument();
        } else if (activeDocData?.type?.toLowerCase() === "company_document") {
          await rejectCompanyDocument();
        }
      }
      setIsRejectEnable(false);
      setRejectionReason(null);
      setIsAcceptableEnable(false);
      setAcceptReason(null);
      await getAllDocuments();
    } catch (err) {
      console.log(err);
      message.error("Something went wrong.")
    } finally {
      setLoad(false);
    }
  };

  const NOT_TOUCH_YET = useMemo(() => {
    return documents?.every((ele) => ele?.auditingDetails === null);
  }, [documents]);

  const IS_DOCUMENT_ACCEPTED =
    activeDocData?.auditingDetails?.documentStatusByMaker === true;
  const IS_DOCUMENT_REJECTED =
    activeDocData?.auditingDetails?.documentStatusByMaker === false;

  let REASON_BY_CENTRAL_HR = "";
  let REASON_BY_SITE_HR = "";
  let ACCEPT_REASON_BY_SITE_HR = "";
  let REASON_BY_CENTRAL_HR_COUNT = 0;
  let REASON_BY_SITE_HR_COUNT = 0;
  let ACCEPT_REASON_BY_SITE_HR_COUNT = 0;

  if (
    activeDocData?.auditingDetails?.rejectionRemarksByChecker !== null &&
    activeDocData?.auditingDetails?.rejectionRemarksByChecker?.length !== 0
  ) {
    REASON_BY_CENTRAL_HR =
      activeDocData?.auditingDetails?.rejectionRemarksByChecker[
        activeDocData?.auditingDetails?.rejectionRemarksByChecker?.length - 1
      ];
    REASON_BY_CENTRAL_HR_COUNT =
      activeDocData?.auditingDetails?.rejectionRemarksByChecker?.length;
  }

  if (
    activeDocData?.auditingDetails?.rejectionRemarksByMaker !== null &&
    activeDocData?.auditingDetails?.rejectionRemarksByMaker?.length !== 0
  ) {
    REASON_BY_SITE_HR =
      activeDocData?.auditingDetails?.rejectionRemarksByMaker[
        activeDocData?.auditingDetails?.rejectionRemarksByMaker?.length - 1
      ];
    REASON_BY_SITE_HR_COUNT =
      activeDocData?.auditingDetails?.rejectionRemarksByMaker?.length;
  }

  if (
    activeDocData?.auditingDetails?.acceptanceRemarksByMaker !== null &&
    activeDocData?.auditingDetails?.acceptanceRemarksByMaker?.length !== 0
  ) {
    ACCEPT_REASON_BY_SITE_HR =
      activeDocData?.auditingDetails?.acceptanceRemarksByMaker[
        activeDocData?.auditingDetails?.acceptanceRemarksByMaker?.length - 1
      ];
    ACCEPT_REASON_BY_SITE_HR_COUNT =
      activeDocData?.auditingDetails?.acceptanceRemarksByMaker?.length;
  }
  const MAX_REJECT_COUNT =
    activeDocData?.auditingDetails?.rejectionCounterByMaker || 0;

  const CENTRAL_HR_NAME =
    activeDocData?.auditingDetails?.auditByUserId?.name || "Central HR";
  const SITE_HR_NAME =
    activeDocData?.auditingDetails?.approveByUserId?.name || "Site HR";
  const IS_CANDIDATE_ACTIVE = personalDetails?.IsCandidateActive || false
  const DOB = personalDetails?.responses?.find(ele => ele?.label === 'Date of Birth')?.value || "N/A"

  if (!permissions.canView) {
    return (
      <Dashboard title="Documents">
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
          <Title level={3}>Access Denied</Title>
        </div>
      </Dashboard>
    );
  }

  return (
    <Dashboard title="Documents">
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}

      <div className="p-4 bg-white rounded">
        <div>
          <Card className="mb-3 review-tab">
            <div className="flex justify-content-between align-items-center">
              <div>
                <Title level={5} className="mb-1 fw-bold">
                  Document Review -{" "}
                  {capitalizeEachWord(
                    `${candidateDetails?.first_name} ${candidateDetails?.last_name}`
                  )}
                </Title>
                {/* <Text>
                  Submitted Date: 5 days ago &nbsp;&nbsp;&nbsp; Days Remaining:
                  3 Days (Mar 29)
                </Text> */}
              </div>
            </div>
          </Card>
          <Card>
            <Row gutter={[16, 16]}>
              <Col xs={24} md={6}>
                <div className="border rounded bg-white  document-tabs">
                  {documents?.length === 0 ? (
                    <div className="mt-4 d-flex justify-content-center">
                      {" "}
                      <Title level={5} className="mb-1 fw-bold">
                        No Document Found
                      </Title>
                    </div>
                  ) : (
                    <Tabs
                      activeKey={String(activeDoc)}
                      tabPosition="left"
                      defaultActiveKey="1"
                      style={{ height: "100%" }}
                      onChange={(e) => {
                        setIsRejectEnable(false);
                        setRejectionReason(null);
                        setActiveDoc(Number(e));
                      }}
                    >
                      {documents?.map((file, index) => {
                        const { auditingDetails } = file;
                        return (
                          <TabPane
                            tab={
                              <span
                                style={{
                                  display: "flex",
                                  gap: "0.5rem",
                                  justifyContent: "space-between",
                                }}
                                className="text-green-600"
                              >
                                <span
                                  style={{
                                    display: "inline-block",
                                    width: "100%",
                                    textAlign: "left",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {file?.name}{" "}
                                </span>
                                {!NOT_TOUCH_YET ? (
                                  <>
                                    {auditingDetails === null ? (
                                      <>
                                        <span
                                          style={{
                                            backgroundColor: "ffffff00",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            width: "25px",
                                            height: "25px",
                                            borderRadius: "50%",
                                          }}
                                          className="bg-red ro"
                                        >
                                          <HourglassOutlined
                                            style={{
                                              color: "#F28222",
                                              margin: "0px",
                                            }}
                                          />
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        {auditingDetails?.documentStatusByCheker ? (
                                          <>
                                            <span
                                              style={{
                                                backgroundColor: "#00AC1A",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                width: "25px",
                                                height: "25px",
                                                borderRadius: "50%",
                                              }}
                                              className="bg-red ro"
                                            >
                                              <CheckOutlined
                                                style={{
                                                  color: "white",
                                                  margin: "0px",
                                                }}
                                              />
                                            </span>
                                          </>
                                        ) : (
                                          <>
                                            <span
                                              style={{
                                                backgroundColor: "red",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                width: "25px",
                                                height: "25px",
                                                borderRadius: "50%",
                                              }}
                                              className="bg-red ro"
                                            >
                                              <CloseOutlined
                                                style={{
                                                  color: "white",
                                                  margin: "0px",
                                                }}
                                              />
                                            </span>
                                          </>
                                        )}
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <></>
                                )}
                              </span>
                            }
                            key={index + 1}
                          />
                        );
                      })}
                    </Tabs>
                  )}
                </div>
              </Col>
              <Col xs={24} md={18}>
                {documents?.length !== 0 ? (
                  <div className="border rounded p-4">
                    {
                      loading ? <>
                        <SkeletonLoader />
                      </> : <>             
                        <div className="flex justify-content-between align-items-center mb-2">
                          <div className="flex gap-2">
                            {
                              IS_CANDIDATE_ACTIVE && permissions.canReupload ?
                              <button
                                className={`__btn px-3 text-white rounded font-weight-bold ${
                                  activeDocData?.auditingDetails
                                    ?.documentStatusByMaker === null
                                    ? "__initial_accepted"
                                    : IS_DOCUMENT_ACCEPTED
                                    ? "__accepted"
                                    : "__disabled"
                                }`}
                                disabled={
                                  IS_DOCUMENT_REJECTED ||
                                  activeDocData?.auditingDetails
                                    ?.documentStatusByMaker !== null
                                }
                                onClick={() => {
                                  setIsRejectEnable(false);
                                  setIsAcceptableEnable(true);
                                  setAcceptReason(null);
                                }}
                              >
                                {" "}
                                <CheckOutlined
                                  style={{
                                    borderRadius: "50%",
                                    padding: 2,
                                    marginRight: "5px",
                                  }}
                                  className={
                                    activeDocData?.auditingDetails
                                      ?.documentStatusByMaker === null
                                      ? "__initial_accepted_icon"
                                      : IS_DOCUMENT_ACCEPTED
                                      ? `__accepted_icon`
                                      : "__disable_icon"
                                  }
                                />
                                Request for Reupload the Document
                              </button> : <></>
                            }
                            {MAX_REJECT_COUNT < 2 && permissions.canNoProblem && (
                              <button
                                className={`__btn px-3 text-white rounded font-weight-bold ${
                                  activeDocData?.auditingDetails
                                    ?.documentStatusByMaker === null
                                    ? "__initial_rejected"
                                    : IS_DOCUMENT_REJECTED
                                    ? "__rejected"
                                    : "__disabled"
                                }`}
                                danger
                                onClick={() => {
                                  setIsAcceptableEnable(false);
                                  setIsRejectEnable(true);
                                  setRejectionReason(null);
                                }}
                                disabled={
                                  IS_DOCUMENT_ACCEPTED ||
                                  activeDocData?.auditingDetails
                                    ?.documentStatusByMaker !== null
                                }
                              >
                                <CloseOutlined
                                  style={{
                                    borderRadius: "50%",
                                    padding: 2,
                                    marginRight: "5px",
                                  }}
                                  className={
                                    activeDocData?.auditingDetails
                                      ?.documentStatusByMaker === null
                                      ? "__initial_rejected_icon"
                                      : IS_DOCUMENT_REJECTED
                                      ? `__rejected_icon`
                                      : "__disable_icon"
                                  }
                                />
                                Not a Problem
                              </button>
                            )}
                            {IS_DOCUMENT_REJECTED && (
                              <Tooltip placement="top" title={REASON_BY_SITE_HR}>
                                <InfoCircleOutlined
                                  style={{
                                    color: "red",
                                    fontSize: "1.1rem",
                                  }}
                                />
                              </Tooltip>
                            )}
                          </div>
                          <div className="flex gap-2">
                            {permissions.canDownload && (
                            <Button
                              onClick={() => downloadDoc()}
                              className="border-0"
                              icon={
                                <span>
                                  <DownloadOutlined />
                                </span>
                              }
                            />
                            )}
                            <Button
                              onClick={() => openDocument()}
                              className="border-0"
                              icon={
                                <span>
                                  <ExportOutlined />
                                </span>
                              }
                            />
                            {permissions.canPrint && (
                            <Button
                              onClick={() => onClickPrint()}
                              className="border-0"
                              icon={
                                <span>
                                  <PrinterOutlined />
                                </span>
                              }
                            />
                            )}
                          </div>
                        </div>
                        {isRejectEnable && (
                          <div className="remark-section mb-2">
                            <strong className="fs-3">Remarks:</strong>
                            <Input
                              value={rejectionReason}
                              onChange={(e) => {
                                console.log(e.target.value);
                                setRejectionReason(e.target.value);
                              }}
                              placeholder="Enter your reason..."
                            />
                            <button
                              disabled={
                                rejectionReason?.trim() === "" ||
                                rejectionReason === null
                              }
                              className={`btn-sm ${
                                rejectionReason?.trim() === "" ||
                                rejectionReason === null
                                  ? "btn-secondary"
                                  : "btn-primary"
                              } __submit`}
                              onClick={() => documentStatusMark(false)}
                            >
                              Submit
                            </button>
                            <button
                              className="btn-sm __cancel"
                              onClick={() => {
                                setRejectionReason(null);
                                setIsRejectEnable(false);
                              }}
                            >
                              Cancel
                            </button>
                          </div>
                        )}
                        {isAcceptableEnable && (
                          <div className="remark-section-accept mb-2">
                            <strong className="fs-3">Remarks:</strong>
                            <Input
                              value={acceptReason}
                              onChange={(e) => {
                                setAcceptReason(e.target.value);
                              }}
                              placeholder="Enter your reason..."
                            />
                            <button
                              disabled={
                                acceptReason?.trim() === "" ||
                                acceptReason === null
                              }
                              className={`btn-sm ${
                                acceptReason?.trim() === "" ||
                                acceptReason === null
                                  ? "btn-secondary"
                                  : "btn-primary"
                              } __submit`}
                              onClick={() => {
                                documentStatusMark(true);
                              }}
                            >
                              Submit
                            </button>
                            <button
                              className="btn-sm __cancel"
                              onClick={() => {
                                setAcceptReason(null);
                                setIsAcceptableEnable(false);
                              }}
                            >
                              Cancel
                            </button>
                          </div>
                        )}
                        <MetaDataTab
                          DOB = {DOB}
                          candidateDetails={candidateDetails}
                          activeDocData={activeDocData}
                        />
                        <div
                          className="text-sm mb-2 px-3 py-2 flex justify-content-between"
                          style={{
                            backgroundColor: "#EBEBEB",
                            justifyContent: "space-between",
                            border: "1px solid #C9C9C9",
                          }}
                        >
                          <span
                            style={{
                              flex: "1 1",
                              borderRight: "1px solid black",
                              textAlign: "center",
                            }}
                          >
                            <span className="font-medium">File Name:</span>{" "}
                            {activeDocData?.docData?.filename}
                          </span>
                          <span
                            style={{
                              flex: "1 1",
                              borderRight: "1px solid black",
                              textAlign: "center",
                            }}
                          >
                            <span className="font-medium">Type:</span>{" "}
                            {activeDocData?.docData?.mimetype}
                          </span>
                          <span
                            style={{
                              flex: "1 1",
                              // borderRight: "1px solid black",
                              textAlign: "center",
                            }}
                          >
                            <span className="font-medium">Size:</span>{" "}
                            {size ? size : ""}
                          </span>
                          {/* <span style={{ flex: "1 1", textAlign: "center" }}>
                            <span className="font-medium">Uploaded:</span> March
                            26 4:56 PM
                          </span> */}
                        </div>
                        {ACCEPT_REASON_BY_SITE_HR !== "" && (
                          <div
                            className="mb-2"
                            style={{
                              height: "33px",
                              background: "#FCFEFC",
                              fontWeight: "bold",
                              border: "1px solid #00AC1A",
                              padding: "5px 10px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              style={{
                                gap: "0.7rem",
                                display: "flex",
                                alignItems: "center",
                                color: "#00AC1A",
                              }}
                            >
                              <span style={{ fontWeight: "bold", color: "#000" }}>
                                {SITE_HR_NAME} {"(Site HR)"} :{" "}
                              </span>
                              <span>
                                <WarningFilled style={{ fontSize: "1.1rem" }} />
                              </span>
                              <span>{ACCEPT_REASON_BY_SITE_HR}</span>
                            </div>
                            {activeDocData?.auditingDetails
                              ?.acceptanceRemarksByMaker !== null && (
                              <Tooltip
                                placement="top"
                                title={
                                  <div>
                                    {activeDocData?.auditingDetails?.acceptanceRemarksByMaker?.map(
                                      (ele, index) => {
                                        return (
                                          <div>
                                            {index + 1} -&gt; {ele}
                                          </div>
                                        );
                                      }
                                    )}
                                  </div>
                                }
                              >
                                <span
                                  style={{
                                    display: "flex",
                                    cursor: "pointer",
                                    backgroundColor: "#00AC1A",
                                    width: "20px",
                                    color: "#fff",
                                    borderRadius: "50%",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  {ACCEPT_REASON_BY_SITE_HR_COUNT}
                                </span>
                              </Tooltip>
                            )}
                          </div>
                        )}
                        {REASON_BY_SITE_HR !== "" && (
                          <div
                            className="mb-2"
                            style={{
                              height: "33px",
                              background: "#FFF8F8",
                              fontWeight: "bold",
                              border: "1px solid #FFC3C3",
                              padding: "5px 10px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              style={{
                                gap: "0.7rem",
                                display: "flex",
                                alignItems: "center",
                                color: "#FF0000",
                              }}
                            >
                              <span style={{ fontWeight: "bold", color: "#000" }}>
                                {SITE_HR_NAME} {"(Site HR)"} :{" "}
                              </span>
                              <span>
                                <WarningFilled style={{ fontSize: "1.1rem" }} />
                              </span>
                              <span>{REASON_BY_SITE_HR}</span>
                            </div>
                            {activeDocData?.auditingDetails
                              ?.rejectionRemarksByMaker !== null && (
                              <Tooltip
                                placement="top"
                                title={
                                  <div>
                                    {activeDocData?.auditingDetails?.rejectionRemarksByMaker?.map(
                                      (ele, index) => {
                                        return (
                                          <div>
                                            {index + 1} -&gt; {ele}
                                          </div>
                                        );
                                      }
                                    )}
                                  </div>
                                }
                              >
                                <span
                                  style={{
                                    display: "flex",
                                    cursor: "pointer",
                                    backgroundColor: "#FF0000",
                                    width: "20px",
                                    color: "#fff",
                                    borderRadius: "50%",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  {REASON_BY_SITE_HR_COUNT}
                                </span>
                              </Tooltip>
                            )}
                          </div>
                        )}
                        {REASON_BY_CENTRAL_HR !== "" && (
                          <div
                            className="mb-2"
                            style={{
                              height: "33px",
                              cursor: "pointer",
                              background: "#FFF8F8",
                              fontWeight: "bold",
                              border: "1px solid #FFC3C3",
                              padding: "5px 10px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              style={{
                                gap: "0.7rem",
                                display: "flex",
                                alignItems: "center",
                                color: "#FF0000",
                              }}
                            >
                              <span style={{ fontWeight: "bold", color: "#000" }}>
                                {CENTRAL_HR_NAME} {"(Central HR)"} :{" "}
                              </span>
                              <span>
                                <WarningFilled style={{ fontSize: "1.1rem" }} />
                              </span>
                              <span>{REASON_BY_CENTRAL_HR}</span>
                            </div>
                            {activeDocData?.auditingDetails
                              ?.rejectionRemarksByChecker !== null && (
                              <Tooltip
                                placement="top"
                                title={
                                  <div>
                                    {activeDocData?.auditingDetails?.rejectionRemarksByChecker?.map(
                                      (ele, index) => {
                                        return (
                                          <div>
                                            {index + 1} -&gt; {ele}
                                          </div>
                                        );
                                      }
                                    )}
                                  </div>
                                }
                              >
                                <span
                                  style={{
                                    display: "flex",
                                    backgroundColor: "#FF0000",
                                    width: "20px",
                                    color: "#fff",
                                    borderRadius: "50%",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  {REASON_BY_CENTRAL_HR_COUNT}
                                </span>
                              </Tooltip>
                            )}
                          </div>
                        )}
                        <div
                          className="relative border rounded"
                          style={{ minHeight: "500px", position: "relative" }}
                        >
                          <div
                            style={{
                              height: "500px",
                              overflowY: "auto",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <RenderFiles
                              src={activeDocData?.path}
                              ext={docExtension}
                            />
                          </div>
                          <div
                            onClick={() => {
                              setIsRejectEnable(false);
                              setRejectionReason(null);
                              if (activeDoc === 1) return;
                              setActiveDoc(activeDoc - 1);
                            }}
                            style={{
                              position: "absolute",
                              top: "50%",
                              transform: "translateY(-50%)",
                              left: -25,
                              background: "#80808000",
                              fontSize: "3.5rem",
                              borderRadius: "50%",
                              width: "50px",
                              height: "50px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              cursor: "pointer",
                              color: "#6B6B6B",
                            }}
                          >
                            <LeftOutlined />
                          </div>
                          <div
                            onClick={() => {
                              setIsRejectEnable(false);
                              setRejectionReason(null);
                              if (documents?.length === activeDoc) return;
                              setActiveDoc(activeDoc + 1);
                            }}
                            style={{
                              cursor: "pointer",
                              position: "absolute",
                              top: "50%",
                              transform: "translateY(-50%)",
                              right: -25,
                              background: "#80808000",
                              fontSize: "3.5rem",
                              borderRadius: "50%",
                              width: "50px",
                              height: "50px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              color: "#6B6B6B",
                            }}
                          >
                            <RightOutlined />
                          </div>
                        </div>
                      </>
                    }
                  </div>
                ) : (
                  <div
                    className="border rounded p-4"
                    style={{
                      minHeight: "750px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Title level={3} className="mb-1 fw-bold">
                      No Document Found
                    </Title>
                  </div>
                )}
              </Col>
            </Row>
          </Card>
        </div>
      </div>
    </Dashboard>
  );
};

export default SiteHrAuditPage;
